/**
 * Created by neo on 07.05.21.
 */
import { v4 as UUID } from 'uuid';

// Observable model type (base fields for composition)
export type Audited = {
  id: string;
  createdAt: string;
  updatedAt: string;
  createdBy?: string;
  updatedBy?: string;
};

// Helper to create audited fields (for composition in other factories)
export function createAuditedFields(json?: Partial<Audited>): Audited {
  return {
    id: json?.id ?? UUID(),
    createdAt: json?.createdAt ?? new Date().toISOString(),
    updatedAt: json?.updatedAt ?? new Date().toISOString(),
    createdBy: json?.createdBy,
    updatedBy: json?.updatedBy,
  };
}
